const notificationInitialState={
    notifications:[],
    isFetching: false,
    notificationsOpen:false,
    isSaving:false,
    saveError: null,
    saveSuccess:null
 };

const notificationReducer=(state=notificationInitialState,action)=>{
    switch(action.type){
        case 'GET_ALL_NOTIFICATIONS_START':
            return {
                ...state,
                isFetching: true,
              };
        case 'GET_ALL_NOTIFICATIONS_SUCCESS':
            return {
                ...state,
                isFetching: false,
                notifications: action.payload,
              };
        case 'GET_ALL_NOTIFICATIONS_FAILURE':
            return {
                ...state,
                isFetching: false,
                saveError: action.payload,
              };
        case 'DELETE_NOTIFICATION_START':
              return{
                ...state,
                isSaving: true,
              }
        case 'DELETE_NOTIFICATION_SUCCESS':
              return{
                ...state,
                isSaving: false,
                notifications: state.notifications.filter(notification=>notification._id!==action.payload.notificationId),
                saveSuccess: action.payload.success,
              }
        case 'DELETE_NOTIFICATION_FAILURE':
            return{
                ...state,
                isSaving: false,
                saveError: action.payload,
              }
        case 'DELETE_ALL_NOTIFICATIONS_START':
                return{
                  ...state,
                  isSaving: true,
                }
        case 'DELETE_ALL_NOTIFICATIONS_SUCCESS':
                return{
                  ...state,
                  isSaving: false,
                  notifications:[],
                  saveSuccess: action.payload,
                }
        case 'DELETE_ALL_NOTIFICATIONS_FAILURE':
              return{
                  ...state,
                  isSaving: false,
                  saveError: action.payload,
                }
        case 'ADD_NOTIFICATION':
            return{
                ...state,
                notifications: [action.payload,...state.notifications],
              }
        case 'TOGGLE_NOTIFICATION_BAR':
            return{
                ...state,
                notificationsOpen:!state.notificationsOpen,
              }
        default:
            return state;
    }
}

export default notificationReducer;